export default {
  computed: {
    bMenuSidebar() {
      return this.$store.state.bMenuSidebar;
    },
  },
};